/**
 * Detail scene
 *
 * @author Mautilus s.r.o.
 * @class Scene_Detail
 * @extends Scene
 */

Scene_Detail = (function (Scene) {

	var Scene_Detail = function () {
		this.construct.apply(this, arguments);
	};

	$.extend(true, Scene_Detail.prototype, Scene.prototype, {
		/**
		 * @inheritdoc Scene#init
		 */
		init: function () {
			this.dontRedraw = false; // prevent to redraw scene
		},

		/**
		 * @inheritdoc Scene#create
		 */
		create: function () {
			return $('#scene-detail');
		},

		/**
		 * @inheritdoc Scene#activate
		 */
		activate: function (item) {
			App.throbber();
			return new Promise(function (resolve, reject) {
				var p1 = API.getDetailData(item);
				var p2 = API.getUserSubscription()

				Promise.all([p1, p2]).then(values => {
					console.log(values[0]);
					console.log(values[1]);
					this.detailData = new Model_Detail(values[0].data.video);
					
					var hasPlans = values[1].data.me.userSuscriptionPlans.length;
					
					var hasSubscriptionPlan = false;
					if(values[1].data.me.userSuscriptionPlans.find(item => item.is_valid && item.suscriptionPlan.type != 'PPV')){
						var subscriptionData = values[1].data.me.userSuscriptionPlans.find(item => item.is_valid && item.suscriptionPlan.type != 'PPV')
						if(values[0].data.video.suscriptionPlans.find(item => item.id == subscriptionData.suscriptionPlan.id))
						{
						  hasSubscriptionPlan = true;
						}
					}
					
					var hasThisVideoPPV = false;
					if(values[1].data.me.userSuscriptionPlans.find(item => item.is_valid && item.videoPPV && item.videoPPV.id == this.detailData.id)){
					  	hasThisVideoPPV = true;
					}
					console.log(Storage.get('email'));
					if (Storage.get('email') == 'desarrollo@beatmobile.com.ar'){
						this.lockClass = true;
					} else {
						this.lockClass = (hasPlans && (hasSubscriptionPlan || hasThisVideoPPV));
					}
					resolve();
					App.throbberHide(false);
				});

			}.bind(this));
		},

		createScene: function() {
			this.buttons = new Snippet_Detail_Buttons(this, {});
			this.buttons.render(this.detailData.attributes.is_favourite);
			this.buttons.on('focus:out', this.onFocusOut, this);
			console.log(JSON.parse(this.detailData.attributes.dynamic_fields));
			var vDynamicFields = JSON.parse(this.detailData.attributes.dynamic_fields);

			var sceneEl =
			'<div id="scene-detail-wrapper">' +
				this.createBackground() +
				'<div class="overlay first"></div>' +
				'<div class="overlay second"></div>' +
                this.createOverhang() +
				this.createTexts() + 
				'<div id="detail-info-box"><p>';

			if(vDynamicFields[__('detail_TYPE')] == __('detail_SERIES')){
				sceneEl += vDynamicFields[__('detail_TYPE')] + ' - '; 
				((vDynamicFields[__('detail_SEASON')]) ? sceneEl += '<span>' + __('detail_SEASON') + ':</span> ' + vDynamicFields[__('detail_SEASON')] + ' - ' : '');
				((vDynamicFields[__('detail_EPISODE')]) ? sceneEl += '<span>' + __('detail_EPISODE') + ':</span> ' + vDynamicFields[__('detail_EPISODE')] + ' - ' : '');
			}
			((this.detailData.attributes.duration) ? sceneEl += '<span>' + __('detail_DURATION') + ':</span> ' + this.convertToDuration(this.detailData.attributes.duration) + '</p>' : '');
			sceneEl += '<p>' + ((vDynamicFields[__('detail_GENRE')]) ? vDynamicFields[__('detail_GENRE')] : '') + ((vDynamicFields[__('detail_YEAR')]) ? ' (' + vDynamicFields[__('detail_YEAR')] + ')' : '') + ((vDynamicFields[__('detail_GENRE')] && vDynamicFields[__('detail_STYLE')]) ? ' - ' : '') + ((vDynamicFields[__('detail_STYLE')]) ? vDynamicFields[__('detail_STYLE')] : '')  + '</p>';
			sceneEl += '<p>' + ((vDynamicFields[__('detail_LOC_PLACE')]) ? vDynamicFields[__('detail_LOC_PLACE')] : '') + ((vDynamicFields[__('detail_LOC_PLACE')] && vDynamicFields[__('detail_LOC_CITY')]) ? ' - ' : '') + ((vDynamicFields[__('detail_LOC_CITY')]) ? vDynamicFields[__('detail_LOC_CITY')] : '') +'</p>';
			((this.detailData.attributes.description) ? sceneEl += '<p><span>' + __('detail_DESCRIPTION') + ':</span> ' + this.detailData.attributes.description +'</p>' : '');
			((vDynamicFields[__('detail_ARTISTS')]) ? sceneEl += '<p><span>' + __('detail_ARTISTS') + ':</span> ' + vDynamicFields[__('detail_ARTISTS')] +'</p>' : '');
			((vDynamicFields[__('detail_RATING')]) ? sceneEl += '<p><span>' + __('detail_RATING') + ':</span> ' + vDynamicFields[__('detail_RATING')] +'</p>' : '');
			sceneEl +='</div></div>';

			return sceneEl;
		},

		createBackground: function() {
			var backgroundDiv = '<div class="image" style="background-image: url(\'' + CONFIG.imageResizerUrl + this.detailData.getBackgroundUrl() + '.xxlarge.jpg\');"></div>';
			return backgroundDiv;
		},

		createOverhang: function() {
			/*var overhangDiv = '<div class="overhang">';
			overhangDiv += '<div class="logo"/>';
			overhangDiv += User.isLogged() ? '<div id="sign-title">'+ User.getUserName() +'</div>': '';
			overhangDiv += User.isLogged() ? '<i id="sign-icon" class="' + (User.isLogged() ? 'logged' : '') + '"></i>' : '';
			overhangDiv += '</div>'
			return overhangDiv;*/
            
            var isLogged = User.isLogged();
			var html = '<div id="overhang">'
            html += '<div class="logo"/>';
			html += '<div id="sign">';
			html += '<div '+(isLogged ? '' : 'class="" data-action="" ')+'id="sign-wrapper">'
			if (isLogged) {
				html += '<div id="sign-title" class="user focusable" data-action="account"><i id="sign-icon" class="logged"></i></div>';
			} else {
				html += '<div id="sign-title" class="login focusable" data-action="login"> '+ __('sign_in') + '<i id="sign-icon"></i></div>';
			}
            html += '<div id="buscar-title" class="login focusable" data-action="search"><i id="search-icon"></i></div>';
			html += '</div>';
			html += '</div>';
            html += '</div>';
			return html;
		},

		createTexts: function() {
			var texts = this.detailData.getTexts();
			var textDiv =
			'<div class="scrollable-area">' +
			'	<div class="text-area">' +
			'		<div class="title">' + texts.title + '</div>' +
			'	</div>' +
			'</div>';
			return textDiv;
		},

		convertToDuration: function(totalSecs) {
			var seconds = totalSecs % 60;
			var minutes = (totalSecs - seconds) / 60 % 60;
			var hours = (((totalSecs - seconds) / 60) - minutes) / 60;

			var vTime = ("0" + hours).slice(-2) + ":" + ("0" + minutes).slice(-2) + ":" + ("0" + seconds).slice(-2);
			return vTime;
		},

		/**
		 * @inheritdoc Scene#render
		 */
		render: function () {
			this.$el.html(this.createScene());
			this.setDescriptionMaxHeight();
			this.$detailWrapper = $('#scene-detail-wrapper', this.$el);
			this.$detailWrapper.append(this.buttons.$el);
            
            this.$signTitle = $('#sign-title', this.$el);
            this.$buscarTitle = $('#buscar-title', this.$el);
		},

		setDescriptionMaxHeight: function() {
			var title = this.$el.find('.title');
			var description = this.$el.find('.description');
			var boundingRect = title[0].getBoundingClientRect();
			if (boundingRect.height > 60) {
				description.css({'max-height': '56', '-webkit-line-clamp': '2'});
			}
		},

		/**
		 * @inheritdoc Scene#onClick
		 */
		onClick: function ($el, event) {
			if (this.trigger('click', $el, event) === false) {
				return false;
			}
			return this.onEnter.apply(this, arguments);
		},
		/**
		 * @inheritdoc Scene#onEnter
		 */
		onEnter: function ($el, event) {
			var action = $el.attr('data-action');
			switch (action) {
				case 'go-back':
					this.exitDetail();
					break;
                case 'login':
			        Router.go('signin');
                    break;
                case 'logout':
                    API.signOut();
                    break;
                case 'search':
			        Router.go('search');
					break;
				case 'account':
			        Router.go('account');
					break;
				case 'closeDialog':
					App.dialog.onClose();
					this.buttons.focus();
					break;
				case 'favorites':
					API.saveFavorites(this.detailData.attributes.id);
					if($el.children("div").first().text() == __("add_favorites")){
						$el.children("div").first().text(__("remove_favorites"));
					} else {
						$el.children("div").first().text(__("add_favorites"));
					}
					
					break;
				case 'playVid':
					var isLocked = !(this.detailData.attributes.video_4k_url && (this.lockClass || this.detailData.attributes.is_free));
					if(!isLocked){
						console.log(this.detailData);
						App.throbber();
            			Router.go('player', this.detailData);
					} else {
						this.showErrDialog();
					}
					break;
			}
			return true;
		},
		/**
		 * @inheritdoc Scene#onReturn
		 */
		onReturn: function ($el, event, stop) {
			stop && stop();
			if(App.dialog) {
				App.dialog.onClose();
				this.buttons.focus();
				return;
			}
			this.exitDetail();
			return false;
		},
		/**
		 * @inheritdoc Scene#navigate
		 */
		navigate: function (direction) {
		},

		/**
		 * @inheritdoc Scene#focus
		 */
		focus: function () {
			if (App.dialog) return false;

      if (typeof this.lastFocusedIndex == 'undefined') {this.buttons.focus();}
		},

		exitDetail: function() {
      		// if (Device.isWEBOS) { return; }
      		this.lastFocusedIndex = undefined;
			Router.go('home');
		},

		showErrDialog: function(event) {
			var dialog = new Snippet_Dialog_error(null, {'selector': 'dialog-error'});
			dialog.setButtons([{ cls: '', action: 'closeDialog', label: 'ok' }]);
			dialog.title = __('player_error');
			dialog.message = __('requires_subscription');
			dialog.render();
			dialog.focus();
			this.errorDialog = dialog;
		},

		/**
		 * @inheritdoc Scene#onBeforeGoBack
		 */
		onBeforeGoBack: function (fromScene) {
			this.dontRedraw = true;
		},

		/**
		 * Cascade focus. Manage the process of Focus delegation between snippets inside Scene
		 *
		 * @param {Object} Snippet or jQuery
		 * @param {String} direction of Focus delegation ("up", "down", "left", "right")
		 */
		onFocusOut: function (snippet, direction) {
			if (direction === 'up') {
                if(snippet === this.buttons)
                    {
                     return Focus.to(this.$buscarTitle);
                    } 
			} else if (direction === 'down') {
			}		
		},
        
        navigate: function (direction) {
            try {
                var currentSelectedSTR = $('.focus').attr('id');
            }
            catch(err) {
                return this.buttons.focus();
            }
            switch (direction) {
                case 'down':
                    if(currentSelectedSTR == 'buscar-title' || currentSelectedSTR == 'sign-title') {
                        return this.buttons.focus();
                    }
                    break;                
                case 'right':
                    if(currentSelectedSTR == 'buscar-title') {
                        Focus.to(this.$signTitle);
                    }
                    break;                    
                case 'left':
                    if(currentSelectedSTR == 'sign-title') {
                        Focus.to(this.$buscarTitle);
                    }
                    break;            
            }
			return false;
		},

		isLocked: function () {
			return this.lockClass;
		}
        
        
	});

    return Scene_Detail;

})(Scene);



//////////////////
// WEBPACK FOOTER
// ./js/scene/detail.js
// module id = 54
// module chunks = 0